webpackJsonp([12],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NEED_LOGIN */
/* unused harmony export SET_USER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERR; });
/* unused harmony export LOADING */
/* unused harmony export SET_ADD_LOGO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ERR_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SUCCESS_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOADING_TOAST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_toast_style__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_store__ = __webpack_require__(83);




var _NEED_LOGIN$USER_LOGI;




var NEED_LOGIN = 'NEED_LOGIN';
var SET_USER = 'SET_USER';
var SET_TOKEN = 'SET_TOKEN';
var USER_LOGIN = 'USER_LOGIN';
var USER_LOGOUT = 'USER_LOGOUT';
var ERR = 'ERR';
var LOADING = 'LOADING';
var SET_ADD_LOGO = 'SET_ADD_LOGO';
var ERR_TOAST = 'ERR_TOAST';
var SUCCESS_TOAST = 'SUCCESS_TOAST';
var LOADING_TOAST = 'LOADING_TOAST';

/* harmony default export */ __webpack_exports__["h"] = (_NEED_LOGIN$USER_LOGI = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NEED_LOGIN$USER_LOGI, NEED_LOGIN, function () {
  __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */].fail({ duration: 500, message: '需要登陆' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NEED_LOGIN$USER_LOGI, USER_LOGIN, function (state, user) {
  state.user = user;
  __WEBPACK_IMPORTED_MODULE_3__util_store__["a" /* default */].set('user', user);
  state.needLogin = false;
  __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */].success({ duration: 500, message: '登陆成功！' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NEED_LOGIN$USER_LOGI, USER_LOGOUT, function (state) {
  state.user = {};
  state.needLogin = true;
  __WEBPACK_IMPORTED_MODULE_3__util_store__["a" /* default */].clear();
  __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */].success({ duration: 500, message: '注销成功！' });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NEED_LOGIN$USER_LOGI, ERR, function (state, message) {
  __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */].fail({ duration: 500, message: message });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NEED_LOGIN$USER_LOGI, SET_TOKEN, function (state, accesstoken) {
  state.accesstoken = accesstoken;
  __WEBPACK_IMPORTED_MODULE_3__util_store__["a" /* default */].set('token', accesstoken);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NEED_LOGIN$USER_LOGI, LOADING, function (state, flag) {
  if (flag) {
    // TODO
  }
  state.loading = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NEED_LOGIN$USER_LOGI, SET_ADD_LOGO, function (state, flag) {
  state.addLogo = flag;
  __WEBPACK_IMPORTED_MODULE_3__util_store__["a" /* default */].set('addLogo', flag);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NEED_LOGIN$USER_LOGI, ERR_TOAST, function (state, _ref) {
  var _ref$message = _ref.message,
      message = _ref$message === undefined ? '操作失败' : _ref$message,
      _ref$mask = _ref.mask,
      mask = _ref$mask === undefined ? false : _ref$mask,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 500 : _ref$duration;

  __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */].fail({
    message: message,
    mask: mask,
    duration: duration
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NEED_LOGIN$USER_LOGI, SUCCESS_TOAST, function (state, _ref2) {
  var _ref2$message = _ref2.message,
      message = _ref2$message === undefined ? '操作成功' : _ref2$message,
      _ref2$mask = _ref2.mask,
      mask = _ref2$mask === undefined ? false : _ref2$mask,
      _ref2$duration = _ref2.duration,
      duration = _ref2$duration === undefined ? 500 : _ref2$duration;

  __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */].success({
    message: message,
    mask: mask,
    duration: duration
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NEED_LOGIN$USER_LOGI, LOADING_TOAST, function (state, _ref3) {
  var flag = _ref3.flag,
      _ref3$message = _ref3.message,
      message = _ref3$message === undefined ? '加载中...' : _ref3$message,
      _ref3$mask = _ref3.mask,
      mask = _ref3$mask === undefined ? true : _ref3$mask;

  if (flag) {
    __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */].loading({
      message: message,
      mask: mask
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_2_vant_es_toast__["a" /* default */].clear();
  }
}), _NEED_LOGIN$USER_LOGI);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchTopic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return postReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return postToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return postUpReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return postTopicCollect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return postTopicDeCollect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return postMarkMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchUserTopicCollect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_index__ = __webpack_require__(91);








function toUrl(INFO, parmas) {
  checkParams(INFO, parmas);
  var str = '';
  var path = INFO.path;
  if (INFO.paramsPath) {
    path = INFO.path.replace(INFO.paramsPath, parmas[INFO.paramsPath.slice(1)]);
  }
  if (INFO.methods === __WEBPACK_IMPORTED_MODULE_6__config_index__["a" /* REQUEST_METHODS */].GET) {
    str += '?';
    for (var key in parmas) {
      if (parmas[key]) {
        str += encodeURIComponent(key) + '=' + encodeURIComponent(parmas[key]) + '&';
      }
    }
    str = str.slice(0, -1);
    return {
      url: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].BASE_URL + path + str
    };
  } else if (INFO.methods === __WEBPACK_IMPORTED_MODULE_6__config_index__["a" /* REQUEST_METHODS */].POST) {
    var DATA = postParam(parmas);
    return {
      url: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].BASE_URL + path,
      data: DATA
    };
  }
}
function checkParams(INFO, params) {
  // 检查是否传递 params
  if (INFO.paramsPath) {
    if (!params[INFO.paramsPath.slice(1)]) {
      throw new Error(INFO.paramsPath.slice(1));
    }
  }
  // 检查params
  if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(INFO.params).length !== 0) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(INFO.params)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        if (INFO.params[key].required === true && params[key] === 'undefined') {
          throw new Error('MUST post ' + key);
        }
        if (typeof INFO.params[key].validator === 'function' && typeof params[key] !== 'undefined') {
          var res = INFO.params[key].validator(params[key]);
          if (!res) {
            throw new Error(key + ' validator \u7C7B\u578B\u9519\u8BEF');
          } else {
            return true;
          }
        }
        // eslint-disable-next-line
        if (INFO.params[key].type !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(params[key]) && typeof params[key] !== 'undefined') {
          throw new Error(key + ' \u5B58\u5728\u7C7B\u578B\u9519\u8BEF');
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
}

function mergeParams(INFO, params) {
  var finallyParams = {};
  var defaultParams = {};
  var keys = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(INFO.params).filter(function (v) {
    return INFO.params[v].default;
  });

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(keys), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      defaultParams[key] = INFO.params[key].default;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(finallyParams, defaultParams, params);
  return finallyParams;
}

var fetchTopics = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPICS, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPICS, params));
            _context.prev = 1;
            _context.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPICS.methods
            });

          case 4:
            res = _context.sent;
            _context.next = 7;
            return res.json();

          case 7:
            return _context.abrupt('return', _context.sent);

          case 10:
            _context.prev = 10;
            _context.t0 = _context['catch'](1);

            console.error(_context.t0);

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[1, 10]]);
  }));

  return function fetchTopics() {
    return _ref.apply(this, arguments);
  };
}();

var fetchTopic = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPIC, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPIC, params));
            _context2.prev = 1;
            _context2.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPIC.methods
            });

          case 4:
            res = _context2.sent;
            _context2.next = 7;
            return res.json();

          case 7:
            return _context2.abrupt('return', _context2.sent);

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2['catch'](1);

            console.error(_context2.t0);

          case 13:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[1, 10]]);
  }));

  return function fetchTopic() {
    return _ref2.apply(this, arguments);
  };
}();

var postReply = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_TOPIC_REPLIES, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_TOPIC_REPLIES, params));
            _context3.prev = 1;
            _context3.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_TOPIC_REPLIES.methods,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              },
              body: URL.data
            });

          case 4:
            res = _context3.sent;
            _context3.next = 7;
            return res.json();

          case 7:
            return _context3.abrupt('return', _context3.sent);

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3['catch'](1);

            console.error(_context3.t0);

          case 13:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this, [[1, 10]]);
  }));

  return function postReply() {
    return _ref3.apply(this, arguments);
  };
}();

function postParam(params) {
  var formBody = [];
  for (var key in params) {
    var encodedKey = encodeURIComponent(key);
    var encodedValue = encodeURIComponent(params[key]);
    if (params[key]) {
      formBody.push(encodedKey + '=' + encodedValue);
    }
  }
  return formBody.join('&');
}

var postToken = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_ACCESSTOKEN, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_ACCESSTOKEN, params));
            _context4.prev = 1;
            _context4.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_ACCESSTOKEN.methods,
              body: URL.data,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              }
            });

          case 4:
            res = _context4.sent;
            _context4.next = 7;
            return res.json();

          case 7:
            return _context4.abrupt('return', _context4.sent);

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4['catch'](1);

            console.error(_context4.t0);

          case 13:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this, [[1, 10]]);
  }));

  return function postToken() {
    return _ref4.apply(this, arguments);
  };
}();

var fetchMessage = function () {
  var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].MESSAGES, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].MESSAGES, params));
            _context5.prev = 1;
            _context5.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].MESSAGES.methods
            });

          case 4:
            res = _context5.sent;
            _context5.next = 7;
            return res.json();

          case 7:
            return _context5.abrupt('return', _context5.sent);

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5['catch'](1);

            console.error(_context5.t0);

          case 13:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, this, [[1, 10]]);
  }));

  return function fetchMessage() {
    return _ref5.apply(this, arguments);
  };
}();

var fetchUser = function () {
  var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].USER, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].USER, params));
            _context6.prev = 1;
            _context6.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].USER.methods
            });

          case 4:
            res = _context6.sent;
            _context6.next = 7;
            return res.json();

          case 7:
            return _context6.abrupt('return', _context6.sent);

          case 10:
            _context6.prev = 10;
            _context6.t0 = _context6['catch'](1);

            console.error(_context6.t0);

          case 13:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, this, [[1, 10]]);
  }));

  return function fetchUser() {
    return _ref6.apply(this, arguments);
  };
}();

var postUpReply = function () {
  var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_UP_REPLY, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_UP_REPLY, params));
            _context7.prev = 1;
            _context7.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_UP_REPLY.methods,
              body: URL.data,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              }
            });

          case 4:
            res = _context7.sent;
            _context7.next = 7;
            return res.json();

          case 7:
            return _context7.abrupt('return', _context7.sent);

          case 10:
            _context7.prev = 10;
            _context7.t0 = _context7['catch'](1);

            console.error(_context7.t0);

          case 13:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, this, [[1, 10]]);
  }));

  return function postUpReply() {
    return _ref7.apply(this, arguments);
  };
}();

var postTopicCollect = function () {
  var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPIC_COLLECT, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPIC_COLLECT, params));
            _context8.prev = 1;
            _context8.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPIC_COLLECT.methods,
              body: URL.data,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              }
            });

          case 4:
            res = _context8.sent;
            _context8.next = 7;
            return res.json();

          case 7:
            return _context8.abrupt('return', _context8.sent);

          case 10:
            _context8.prev = 10;
            _context8.t0 = _context8['catch'](1);

            console.error(_context8.t0);

          case 13:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, this, [[1, 10]]);
  }));

  return function postTopicCollect() {
    return _ref8.apply(this, arguments);
  };
}();

var postTopicDeCollect = function () {
  var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPIC_DE_COLLECT, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPIC_DE_COLLECT, params));
            _context9.prev = 1;
            _context9.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].TOPIC_DE_COLLECT.methods,
              body: URL.data,
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              }
            });

          case 4:
            res = _context9.sent;
            _context9.next = 7;
            return res.json();

          case 7:
            return _context9.abrupt('return', _context9.sent);

          case 10:
            _context9.prev = 10;
            _context9.t0 = _context9['catch'](1);

            console.error(_context9.t0);

          case 13:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, this, [[1, 10]]);
  }));

  return function postTopicDeCollect() {
    return _ref9.apply(this, arguments);
  };
}();
var postMarkMessage = function () {
  var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_MARK_ONE_MESSAGE, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_MARK_ONE_MESSAGE, params));
            _context10.prev = 1;
            _context10.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].POST_MARK_ONE_MESSAGE.methods
            });

          case 4:
            res = _context10.sent;
            _context10.next = 7;
            return res.json();

          case 7:
            return _context10.abrupt('return', _context10.sent);

          case 10:
            _context10.prev = 10;
            _context10.t0 = _context10['catch'](1);

            console.error(_context10.t0);

          case 13:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, this, [[1, 10]]);
  }));

  return function postMarkMessage() {
    return _ref10.apply(this, arguments);
  };
}();

var fetchUserTopicCollect = function () {
  var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var URL, res;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            URL = toUrl(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].USER_TOPIC_COLLECT, mergeParams(__WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].USER_TOPIC_COLLECT, params));
            _context11.prev = 1;
            _context11.next = 4;
            return fetch(URL.url, {
              method: __WEBPACK_IMPORTED_MODULE_6__config_index__["c" /* default */].USER_TOPIC_COLLECT.methods
            });

          case 4:
            res = _context11.sent;
            _context11.next = 7;
            return res.json();

          case 7:
            return _context11.abrupt('return', _context11.sent);

          case 10:
            _context11.prev = 10;
            _context11.t0 = _context11['catch'](1);

            console.error(_context11.t0);

          case 13:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, this, [[1, 10]]);
  }));

  return function fetchUserTopicCollect() {
    return _ref11.apply(this, arguments);
  };
}();

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */,
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vant_es_actionsheet_style__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vant_es_actionsheet__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vant_es_toast_style__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vant_es_toast__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vant_es_pull_refresh_style__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vant_es_pull_refresh__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dayjs__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dayjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dayjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dayjs_locale_zh_cn__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dayjs_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dayjs_locale_zh_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dayjs_plugin_relativeTime__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dayjs_plugin_relativeTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dayjs_plugin_relativeTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_animate_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__base_Icon__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_reset_css__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_reset_css__);


















// reset.css

// 全局组件

__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vant_es_pull_refresh__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vant_es_toast__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vant_es_actionsheet__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].component(__WEBPACK_IMPORTED_MODULE_14__base_Icon__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_14__base_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_7_dayjs___default.a.locale('zh-cn');
__WEBPACK_IMPORTED_MODULE_7_dayjs___default.a.extend(__WEBPACK_IMPORTED_MODULE_9_dayjs_plugin_relativeTime___default.a);

__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].filter('time', function (v) {
  return __WEBPACK_IMPORTED_MODULE_7_dayjs___default()(v).fromNow();
});

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_11__App__["a" /* default */]);
  }
}));

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

var prefix = 'icon-';
var activFix = 'fill';
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-icon',
  props: {
    icon: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: 'inherit'
    },
    active: {
      type: Boolean,
      default: false
    },
    activeIcon: {
      type: String
    }
  },
  computed: {
    iconClass: function iconClass() {
      var icon = '';
      if (this.icon.indexOf(prefix) === -1) {
        icon += prefix;
      }
      icon += this.icon;
      if (this.active) {
        icon += activFix;
      }
      return icon;
    }
  }
});

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
  set: function set(key, value) {
    try {
      var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value);
      console.assert(str);
      return localStorage.setItem(key, str);
    } catch (error) {
      console.error('key', key);
      console.error(error);
    }
  },
  get: function get(key) {
    if (!key) {
      return null;
    }
    try {
      var res = localStorage.getItem(key);
      return JSON.parse(res);
    } catch (error) {
      console.error('key', key);
      console.error(error);
    }
  },
  clear: function clear() {
    try {
      return localStorage.clear();
    } catch (error) {
      console.error(error);
    }
  },
  remove: function remove(key) {
    if (key) {
      try {
        return localStorage.clear();
      } catch (error) {
        console.error(error);
      }
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NEED_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_TOPIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_COLLECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERR; });
/* unused harmony export CALL_BACK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_UP_REPLY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _SET_ID$SET_TOPIC$LOA;

var NEED_LOGIN = 'NEED_LOGIN';
var SET_ID = 'SET_ID';
var SET_TOPIC = 'SET_TOPIC';
var SET_COLLECT = 'SET_COLLECT';
var LOADING = 'LOADING';
var ERR = 'ERR';
var CALL_BACK = 'CALL_BACK';
var SET_UP_REPLY = 'SET_UP_REPLY';

/* harmony default export */ __webpack_exports__["h"] = (_SET_ID$SET_TOPIC$LOA = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ID$SET_TOPIC$LOA, SET_ID, function (state, id) {
  state.id = id;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ID$SET_TOPIC$LOA, SET_TOPIC, function (state, topic) {
  state.topic = topic;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ID$SET_TOPIC$LOA, LOADING, function (state, tag) {
  state.loading = tag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ID$SET_TOPIC$LOA, ERR, function (state, msg) {
  state.msg = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ID$SET_TOPIC$LOA, SET_COLLECT, function (state, tag) {
  state.topic.is_collect = tag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ID$SET_TOPIC$LOA, SET_UP_REPLY, function (state, _ref) {
  var flag = _ref.flag,
      id = _ref.id;

  state.topic.replies.forEach(function (item) {
    if (item.id === id) {
      if (flag === 'up') {
        item.is_uped = true;
        item.ups.push('点赞');
      } else {
        item.is_uped = false;
        item.ups.pop();
      }
    }
  });
}), _SET_ID$SET_TOPIC$LOA);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PUSH_TOPICS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UNSHIFT_TOPICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHIFT_TOPICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGE_ADD_ONE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);



var _PUSH_TOPICS$UNSHIFT_;

var PUSH_TOPICS = 'PUSH_TOPICS';
var UNSHIFT_TOPICS = 'UNSHIFT_TOPICS';
var SHIFT_TOPICS = 'SHIFT_TOPICS';
var LOADING = 'LOADING';
var ERR = 'ERR';
var PAGE_ADD_ONE = 'PAGE_ADD_ONE';

/* harmony default export */ __webpack_exports__["f"] = (_PUSH_TOPICS$UNSHIFT_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PUSH_TOPICS$UNSHIFT_, PUSH_TOPICS, function (state, topics) {
  var _state$topics;

  (_state$topics = state.topics).push.apply(_state$topics, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(topics));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PUSH_TOPICS$UNSHIFT_, UNSHIFT_TOPICS, function (state, topics) {
  var _state$topics2;

  (_state$topics2 = state.topics).unshift.apply(_state$topics2, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(topics));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PUSH_TOPICS$UNSHIFT_, SHIFT_TOPICS, function (state, conut) {
  state.topics.splice(-conut);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PUSH_TOPICS$UNSHIFT_, ERR, function (state, msg) {
  state.err = true;
  state.msg = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PUSH_TOPICS$UNSHIFT_, LOADING, function (state, flag) {
  state.loading = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PUSH_TOPICS$UNSHIFT_, PAGE_ADD_ONE, function (state) {
  state.page += 1;
}), _PUSH_TOPICS$UNSHIFT_);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ERR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MESSAGE_READ; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _SET_MESSAGE$SET_LOAD;

/* eslint camelcase: 0 */
var SET_MESSAGE = 'SET_MESSAGE';
var SET_LOADING = 'SET_LOADING';
var SET_ERR = 'SET_ERR';
var MESSAGE_READ = 'MESSAGE_READ';

/* harmony default export */ __webpack_exports__["e"] = (_SET_MESSAGE$SET_LOAD = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MESSAGE$SET_LOAD, SET_MESSAGE, function (state, _ref) {
  var hasnot_read_messages = _ref.hasnot_read_messages,
      has_read_messages = _ref.has_read_messages;

  state.none = hasnot_read_messages;
  state.read = has_read_messages;
  state.err = false;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MESSAGE$SET_LOAD, SET_LOADING, function (state, tag) {
  if (tag) {
    // TODO
  }
  state.loading = tag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MESSAGE$SET_LOAD, SET_ERR, function (state, _ref2) {
  var tag = _ref2.tag,
      msg = _ref2.msg;

  if (tag) {
    // TODO
  }
  state.tag = tag;
  state.errmsg = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_MESSAGE$SET_LOAD, MESSAGE_READ, function (state, _ref3) {
  var id = _ref3.id;

  var index = state.none.findIndex(function (message) {
    return message.id === id;
  });
  if (index) {
    state.none.splice(index, 1);
  }
}), _SET_MESSAGE$SET_LOAD);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UNSHIFT_TOPICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHIFT_TOPICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGE_ADD_ONE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);



var _UNSHIFT_TOPICS$SHIFT;

var UNSHIFT_TOPICS = 'UNSHIFT_TOPICS';
var SHIFT_TOPICS = 'SHIFT_TOPICS';
var LOADING = 'LOADING';
var ERR = 'ERR';
var PAGE_ADD_ONE = 'PAGE_ADD_ONE';
/* harmony default export */ __webpack_exports__["f"] = (_UNSHIFT_TOPICS$SHIFT = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNSHIFT_TOPICS$SHIFT, UNSHIFT_TOPICS, function (state, _ref) {
  var _state$tab$topics;

  var tab = _ref.tab,
      topics = _ref.topics;

  (_state$tab$topics = state[tab].topics).unshift.apply(_state$tab$topics, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(topics));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNSHIFT_TOPICS$SHIFT, SHIFT_TOPICS, function (state, _ref2) {
  var tab = _ref2.tab,
      conut = _ref2.conut;

  state[tab].topics.splice(-conut);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNSHIFT_TOPICS$SHIFT, ERR, function (state, _ref3) {
  var tab = _ref3.tab,
      msg = _ref3.msg;

  state[tab].err = true;
  state[tab].msg = msg;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNSHIFT_TOPICS$SHIFT, LOADING, function (state, _ref4) {
  var tab = _ref4.tab,
      flag = _ref4.flag;

  state[tab].loading = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_UNSHIFT_TOPICS$SHIFT, PAGE_ADD_ONE, function (state, _ref5) {
  var tab = _ref5.tab;

  state[tab].page += 1;
}), _UNSHIFT_TOPICS$SHIFT);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ERR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_AUTHOR_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_AUTHOR_COLLECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEED_ROUTER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(55);


var _SET_ERR$SET_AUTHOR_I;


var SET_ERR = 'SET_ERR';
var SET_AUTHOR_INFO = 'SET_AUTHOR_INFO';
var SET_AUTHOR_COLLECTS = 'SET_AUTHOR_COLLECTS';
var SET_LOADING = 'SET_LOADING';
var NEED_ROUTER = 'NEED_ROUTER';

/* harmony default export */ __webpack_exports__["f"] = (_SET_ERR$SET_AUTHOR_I = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ERR$SET_AUTHOR_I, SET_ERR, function (state, _ref) {
  var flag = _ref.flag,
      msg = _ref.msg;

  state.err = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ERR$SET_AUTHOR_I, SET_AUTHOR_INFO, function (state, _ref2) {
  var data = _ref2.data;

  if (data) {
    state.author.info = data;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ERR$SET_AUTHOR_I, SET_AUTHOR_COLLECTS, function (state, _ref3) {
  var data = _ref3.data;

  if (data) {
    state.author.collects = data;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ERR$SET_AUTHOR_I, SET_LOADING, function (state, _ref4) {
  var flag = _ref4.flag;

  state.loading = flag;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_ERR$SET_AUTHOR_I, 'NEED_ROUTER', function NEED_ROUTER(state, path) {
  __WEBPACK_IMPORTED_MODULE_1__main__["default"].$router.push(path);
}), _SET_ERR$SET_AUTHOR_I);

/***/ }),
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(68);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60395e6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(139);
function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var normalizeComponent = __webpack_require__(51)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60395e6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TABS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TABS_NAME; });
/* unused harmony export CODE */
/* unused harmony export TAB_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REQUEST_METHODS; });

var TABS = ['ask', 'share', 'job', 'good', 'dev'];
var TABS_NAME = {
  ask: '问答',
  share: '分享',
  job: '招聘',
  good: '精华',
  dev: '测试'
};

var CODE = {
  SUCCESS: 0,
  FAIL: 1
};

var TAB_NAME = ['问答', '分享', '招聘', '精华'];

var REQUEST_METHODS = {
  POST: 'POST',
  GET: 'GET'
};

/* harmony default export */ __webpack_exports__["c"] = ({
  BASE_URL: 'https://cnodejs.org/api/v1',
  TOPICS: {
    path: '/topics',
    methods: REQUEST_METHODS.GET,
    params: {
      page: {
        type: 'number',
        default: 1
      },
      tab: {
        validator: function validator(v) {
          return TABS.indexOf(v) !== -1;
        }
      },
      limit: {
        type: 'number',
        default: 10
      },
      mdrender: {
        type: 'boolean',
        default: true
      }
    }
  },
  TOPIC: {
    path: '/topic/:id',
    paramsPath: ':id',
    methods: REQUEST_METHODS.GET,
    params: {
      mdrender: {
        type: 'boolean',
        default: true
      },
      accesstoken: {
        type: 'string'
      }
    }
  },
  POST_TOPIC: {
    path: '/topics',
    methods: REQUEST_METHODS.POST,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      },
      tab: {
        validator: function validator(v) {
          return TABS.indexOf(v) !== -1;
        }
      },
      title: {
        type: 'string'
      },
      content: {
        required: true,
        validator: function validator(v) {
          return v.length >= 10;
        }
      }
    }
  },
  UPDATE_TOPIC: {
    path: '/topics/update',
    methods: REQUEST_METHODS.POST,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      },
      tab: {
        validator: function validator(v) {
          return TABS.indexOf(v) !== -1;
        }
      },
      topic_id: {
        type: 'string',
        required: true
      },
      title: {
        type: 'string'
      },
      content: {
        required: true,
        validator: function validator(v) {
          return v.length >= 10;
        }
      }
    }
  },
  TOPIC_COLLECT: {
    path: '/topic_collect/collect',
    methods: REQUEST_METHODS.POST,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      },
      topic_id: {
        type: 'string',
        required: true
      }
    }
  },
  TOPIC_DE_COLLECT: {
    path: '/topic_collect/de_collect',
    methods: REQUEST_METHODS.POST,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      },
      topic_id: {
        type: 'string',
        required: true
      }
    }
  },
  USER_TOPIC_COLLECT: {
    path: '/topic_collect/:loginname',
    methods: REQUEST_METHODS.GET,
    paramsPath: ':loginname',
    params: {}
  },
  // post /topic/:topic_id/replies 新建评论
  POST_TOPIC_REPLIES: {
    path: '/topic/:topic_id/replies',
    paramsPath: ':topic_id',
    methods: REQUEST_METHODS.POST,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      },
      content: {
        required: true,
        validator: function validator(v) {
          return v.length >= 1;
        }
      },
      reply_id: {
        type: 'string'
      }
    }
  },
  // post /reply/:reply_id/ups 为评论点赞
  POST_UP_REPLY: {
    path: '/reply/:reply_id/ups',
    paramsPath: ':reply_id',
    methods: REQUEST_METHODS.POST,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      }
    }
  },
  // get /user/:loginname 用户详情
  USER: {
    path: '/user/:loginname',
    paramsPath: ':loginname',
    methods: REQUEST_METHODS.GET,
    params: {}
  },
  // post /accesstoken 验证 accessToken 的正确性
  POST_ACCESSTOKEN: {
    path: '/accesstoken',
    methods: REQUEST_METHODS.POST,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      }
    }
  },
  // get /message/count 获取未读消息数
  MESSAGE_COUNT: {
    path: '/message/count',
    methods: REQUEST_METHODS.GET,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      }
    }
  },
  // get /messages 获取已读和未读消息
  MESSAGES: {
    path: '/messages',
    methods: REQUEST_METHODS.GET,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      },
      mdrender: {
        type: 'boolean'
      }
    }
  },
  // post /message/mark_all 标记全部已读
  POST_MARK_ALL_MESSAGE: {
    path: '/message/mark_all',
    methods: REQUEST_METHODS.POST,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      }
    }
  },
  // post /message/mark_one/:msg_id
  POST_MARK_ONE_MESSAGE: {
    path: '/message/mark_one/:msg_id',
    pathParams: ':msg_id',
    methods: REQUEST_METHODS.POST,
    params: {
      accesstoken: {
        type: 'string',
        required: true
      }
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__topic__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__message__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__category__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reply__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__author__ = __webpack_require__(200);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    topic: __WEBPACK_IMPORTED_MODULE_3__topic__["a" /* default */],
    home: __WEBPACK_IMPORTED_MODULE_4__home__["a" /* default */],
    category: __WEBPACK_IMPORTED_MODULE_6__category__["a" /* default */],
    message: __WEBPACK_IMPORTED_MODULE_5__message__["a" /* default */],
    reply: __WEBPACK_IMPORTED_MODULE_7__reply__["a" /* default */],
    author: __WEBPACK_IMPORTED_MODULE_8__author__["a" /* default */]
  }
}));

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d78a876_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(132);
function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var normalizeComponent = __webpack_require__(51)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d78a876_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"exclude":"page-topic"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(134);



var Home = function Home() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 206));
};
var Category = function Category() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 207));
};
var Message = function Message() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 208));
};
var Me = function Me() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 209));
};
var Root = function Root() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 210));
};
var Topic = function Topic() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 211));
};
var User = function User() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 212));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 213));
};
var Reply = function Reply() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 214));
};
// const Image = () => import('../pages/Image')
var Collect = function Collect() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 215));
};
var NotFound = function NotFound() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 216));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    component: Root,
    children: [{
      path: '/category',
      component: Category
    }, {
      path: '/',
      component: Home
    }, {
      path: '/me',
      component: Me
    }, {
      path: '/message',
      component: Message
    }]
  }, {
    path: '/topic/:id',
    component: Topic,
    children: [{
      path: '/topic/:id/reply',
      component: Reply
      // {
      //   path: '/topic/:id/image',
      //   component: Image
      // }
    }]
  }, {
    path: '/user/:name',
    component: User,
    children: [{
      path: '/user/:name/collect',
      component: Collect
    }]
  }, {
    path: '/login',
    component: Login
  }, {
    path: '*',
    component: NotFound
  }]
}));

/***/ }),
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:['iconfont', _vm.iconClass],style:({fontSize: _vm.size + 'px', color: _vm.color})})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_store__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(180);





var initAccesstoken = __WEBPACK_IMPORTED_MODULE_0__util_store__["a" /* default */].get('token') || '';
var initUser = __WEBPACK_IMPORTED_MODULE_0__util_store__["a" /* default */].get('user') || {};
var initAddLogo = typeof __WEBPACK_IMPORTED_MODULE_0__util_store__["a" /* default */].get('addLogo') === 'boolean' ? __WEBPACK_IMPORTED_MODULE_0__util_store__["a" /* default */].get('addLogo') : true;

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: initUser,
    needLogin: !(initUser && initAccesstoken),
    accesstoken: initAccesstoken,
    loading: false,
    addLogo: initAddLogo
  },
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["h" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
});

/***/ }),
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  token: function token(state) {
    if (state.accesstoken) {
      return state.accesstoken;
    }
    return '';
  },
  needLogin: function needLogin(state) {
    return state.needLogin;
  },
  loading: function loading(state) {
    return state.loading;
  },
  user: function user(state) {
    if (state.user && state.user.success) {
      return { avatar_url: state.user.avatar_url, loginname: state.user.loginname };
    } else {
      return { avatar_url: '', loginname: '' };
    }
  },
  addLogo: function addLogo(state) {
    return state.addLogo;
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_api__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["a"] = ({
  userLogin: function userLogin(_ref, _ref2) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state;
    var accesstoken = _ref2.accesstoken,
        cb = _ref2.cb;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["h" /* postToken */])({ accesstoken: accesstoken });

            case 3:
              res = _context.sent;

              if (res.success) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["f" /* USER_LOGIN */], res);
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* SET_TOKEN */], accesstoken);
                if (cb) {
                  cb();
                }
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], res);
              }
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context['catch'](0);

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], '未知错误');

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 7]]);
    }))();
  },
  userLogout: function userLogout(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["g" /* USER_LOGOUT */]);
    commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* SET_TOKEN */], '');
  }
});

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(186);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    id: null,
    topic: null,
    err: false,
    loading: false,
    msg: '',
    complete: false
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["h" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  topic: function topic(state) {
    if (state.topic) {
      return state.topic;
    }
    return {};
  },
  isLoading: function isLoading(state) {
    return state.loading;
  },
  isErr: function isErr(state) {
    return state.err;
  },
  author: function author(state) {
    if (state.topic) {
      return state.topic.author;
    }
    return null;
  },
  collect: function collect(state) {
    if (state.topic) {
      return state.topic.is_collect;
    }
    return false;
  },
  replies: function replies(state) {
    if (state.topic) {
      return state.topic.replies;
    }
    return [];
  },
  images: function images(state) {
    if (state.topic) {
      var reg = /<img src="(\S+?)".+?>/g;
      var res = state.topic.content.match(reg);
      return res || [];
    }
    return [];
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_mutations__ = __webpack_require__(14);


/* eslint camelcase: 0 */




/* harmony default export */ __webpack_exports__["a"] = ({
  getTopic: function getTopic(_ref, _ref2) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state,
        rootGetters = _ref.rootGetters;
    var id = _ref2.id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var accesstoken, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              accesstoken = rootGetters.token;

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["e" /* SET_ID */], id);
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* LOADING */], true);
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["c" /* LOADING_TOAST */], { flag: true }, { root: true });
              _context.prev = 4;
              _context.next = 7;
              return Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["b" /* fetchTopic */])({ id: id, accesstoken: accesstoken });

            case 7:
              res = _context.sent;

              if (res.success) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["f" /* SET_TOPIC */], res.data);
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], res.error_msg);
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: res.error_msg }, { root: true });
              }
              _context.next = 16;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](4);

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* LOADING */], false);
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], _context.t0);
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: '未知错误!' }, { root: true });

            case 16:
              _context.prev = 16;

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* LOADING */], false);
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["c" /* LOADING_TOAST */], { flag: false }, { root: true });
              return _context.finish(16);

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 11, 16, 20]]);
    }))();
  },
  topicCollect: function topicCollect(_ref3) {
    var _this2 = this;

    var commit = _ref3.commit,
        state = _ref3.state,
        rootGetters = _ref3.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var accesstoken, id, isCollect, func, res, message;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              accesstoken = rootGetters.token;
              id = state.id;
              isCollect = state.topic.is_collect;
              func = isCollect ? __WEBPACK_IMPORTED_MODULE_3__util_api__["j" /* postTopicDeCollect */] : __WEBPACK_IMPORTED_MODULE_3__util_api__["i" /* postTopicCollect */];

              if (accesstoken) {
                _context2.next = 7;
                break;
              }

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* NEED_LOGIN */], null, { root: true });
              return _context2.abrupt('return');

            case 7:
              _context2.prev = 7;
              _context2.next = 10;
              return func({ accesstoken: accesstoken, topic_id: id });

            case 10:
              res = _context2.sent;

              if (res.success) {
                message = isCollect ? '取消成功' : '收藏成功';

                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* SET_COLLECT */], !isCollect);
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["e" /* SUCCESS_TOAST */], { message: message }, { root: true });
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], res.error_msg);
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["e" /* SUCCESS_TOAST */], { message: res.error_msg }, { root: true });
              }
              _context2.next = 18;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2['catch'](7);

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], _context2.t0);
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["e" /* SUCCESS_TOAST */], { message: '未知错误' }, { root: true });

            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[7, 14]]);
    }))();
  },
  upReply: function upReply(_ref4, _ref5) {
    var _this3 = this;

    var commit = _ref4.commit,
        state = _ref4.state,
        rootGetters = _ref4.rootGetters;
    var reply_id = _ref5.reply_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var accesstoken, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              accesstoken = rootGetters.token;

              if (accesstoken) {
                _context3.next = 4;
                break;
              }

              console.log('accesstoken', accesstoken);
              return _context3.abrupt('return', commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* NEED_LOGIN */], null, { root: true }));

            case 4:
              _context3.prev = 4;
              _context3.next = 7;
              return Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["k" /* postUpReply */])({ accesstoken: accesstoken, reply_id: reply_id });

            case 7:
              res = _context3.sent;

              if (res.success) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["g" /* SET_UP_REPLY */], { flag: res.action, id: reply_id });
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], res.error_msg);
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: res.error_msg }, { root: true });
              }
              _context3.next = 15;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3['catch'](4);

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], _context3.t0);
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: '未知错误' }, { root: true });

            case 15:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3, [[4, 11]]);
    }))();
  },
  deleteTopic: function deleteTopic(_ref6) {
    var commit = _ref6.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["f" /* SET_TOPIC */], null);
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(189);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    topics: [],
    page: 1,
    err: false,
    loading: false,
    msg: ''
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["f" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  topics: function topics(state) {
    return state.topics;
  },
  isLoading: function isLoading(state) {
    return state.loading;
  },
  isErr: function isErr(state) {
    return state.err;
  },
  page: function page(state) {
    return state.page;
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_mutations__ = __webpack_require__(14);






/* harmony default export */ __webpack_exports__["a"] = ({
  getTopics: function getTopics(_ref) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state;
    var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* LOADING */], true);
              if (init) {
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["c" /* LOADING_TOAST */], { flag: true, message: '初始化...' }, { root: true });
              }
              _context.next = 5;
              return Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["c" /* fetchTopics */])({ page: state.page });

            case 5:
              res = _context.sent;

              if (res.success) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["e" /* UNSHIFT_TOPICS */], res.data);
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* PAGE_ADD_ONE */]);
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* LOADING */], false);
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* LOADING */], false);
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], res);
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: res.error_msg }, { root: true });
              }
              if (state.topics.length >= 60) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* SHIFT_TOPICS */], 10);
              }
              _context.next = 15;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](0);

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* LOADING */], false);
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], _context.t0);
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: '未知错误' }, { root: true });

            case 15:
              if (init) {
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["c" /* LOADING_TOAST */], { flag: false }, { root: true });
              }

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 10]]);
    }))();
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(192);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    read: [],
    none: [],
    err: false,
    loading: false,
    errmsg: ''
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["e" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  read: function read(state) {
    return state.read;
  },
  none: function none(state) {
    return state.none;
  },
  loading: function loading(state) {
    return state.loading;
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_api__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["a"] = ({
  getMessage: function getMessage(_ref) {
    var _this = this;

    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var accesstoken, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* SET_LOADING */], true);
              accesstoken = rootGetters.token;

              if (accesstoken) {
                _context.next = 6;
                break;
              }

              setTimeout(function () {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* SET_LOADING */], false);
              }, 200);
              commit('NEED_LOGIN', null, { root: true });
              return _context.abrupt('return');

            case 6:
              _context.prev = 6;
              _context.next = 9;
              return Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["a" /* fetchMessage */])({ accesstoken: accesstoken });

            case 9:
              res = _context.sent;

              if (res.success) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* SET_MESSAGE */], res.data);
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* SET_ERR */], { tag: true, msg: res.error_msg });
              }
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* SET_LOADING */], false);
              _context.next = 19;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context['catch'](6);

              console.error(_context.t0);
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* SET_ERR */], { tag: true, msg: _context.t0 });
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* SET_LOADING */], false);

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[6, 14]]);
    }))();
  },
  markMessage: function markMessage(_ref2, _ref3) {
    var _this2 = this;

    var commit = _ref2.commit,
        rootGetters = _ref2.rootGetters;
    var id = _ref3.id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var accesstoken, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              accesstoken = rootGetters.token;
              _context2.prev = 1;
              _context2.next = 4;
              return Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["f" /* postMarkMessage */])({ accesstoken: accesstoken, msg_id: id });

            case 4:
              res = _context2.sent;

              if (res.success) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* MESSAGE_READ */], { id: res.data.marked_msg_id });
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* SET_ERR */], { tag: true, msg: res.error_msg });
              }
              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](1);

              console.error(_context2.t0);
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* SET_ERR */], { tag: true, msg: _context2.t0 });

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[1, 8]]);
    }))();
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(195);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    good: {
      page: 1,
      topics: [],
      err: false,
      loading: false
    },
    job: {
      page: 1,
      topics: [],
      err: false,
      loading: false
    },
    share: {
      page: 1,
      topics: [],
      err: false,
      loading: false
    },
    dev: {
      page: 1,
      topics: [],
      err: false,
      loading: false
    },
    ask: {
      page: 1,
      topics: [],
      err: false,
      loading: false
    }
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["f" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  good: function good(state) {
    return state.good.topics;
  },
  job: function job(state) {
    return state.job.topics;
  },
  ask: function ask(state) {
    return state.ask.topics;
  },
  share: function share(state) {
    return state.share.topics;
  },
  dev: function dev(state) {
    return state.dev.topics;
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_mutations__ = __webpack_require__(14);






/* harmony default export */ __webpack_exports__["a"] = ({
  getTopics: function getTopics(_ref, _ref2) {
    var _this = this;

    var commit = _ref.commit,
        state = _ref.state;
    var tab = _ref2.tab;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (state[tab].topics.length === 0) {
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["c" /* LOADING_TOAST */], { flag: true }, { root: true });
              }
              _context.prev = 1;

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* LOADING */], { tab: tab, flag: true });
              _context.next = 5;
              return Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["c" /* fetchTopics */])({ page: state[tab].page, tab: tab });

            case 5:
              res = _context.sent;

              if (res.success) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["e" /* UNSHIFT_TOPICS */], { tab: tab, topics: res.data });
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* PAGE_ADD_ONE */], { tab: tab });
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], { tab: tab, msg: res.error_msg });
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: res.error_msg }, { root: true });
              }
              if (state[tab].topics.length >= 60) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* SHIFT_TOPICS */], { tab: tab, conut: 10 });
              }
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](1);

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* ERR */], { tab: tab, msg: _context.t0 });
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: '未知错误' }, { root: true });

            case 14:
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* LOADING */], { tab: tab, flag: false });
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["c" /* LOADING_TOAST */], { flag: false }, { root: true });

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 10]]);
    }))();
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(199);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    reply: null,
    at: [],
    err: false,
    loading: false,
    errmsg: ''
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PUSH_AT_USER */
/* unused harmony export REMOVE_AT_USER */
/* unused harmony export SET_REPLY */
/* unused harmony export SET_LOADING */
/* unused harmony export SET_ERR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

/* eslint camelcase: 0 */
var PUSH_AT_USER = 'PUSH_AT_USER';
var REMOVE_AT_USER = 'REMOVE_AT_USER';
var SET_REPLY = 'SET_REPLY';
var SET_LOADING = 'SET_LOADING';
var SET_ERR = 'SET_ERR';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, PUSH_AT_USER, function (state, user) {
  state.at.push(user);
}));

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_mutations__ = __webpack_require__(14);


/* eslint camelcase: 0 */



/* harmony default export */ __webpack_exports__["a"] = ({
  reply: function reply(_ref, _ref2) {
    var _this = this;

    var commit = _ref.commit,
        rootGetters = _ref.rootGetters;
    var content = _ref2.content,
        topic_id = _ref2.topic_id,
        reply_id = _ref2.reply_id;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var accesstoken, addLogo, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              accesstoken = rootGetters.token;
              addLogo = rootGetters.addLogo;

              if (accesstoken) {
                _context.next = 4;
                break;
              }

              return _context.abrupt('return', commit('NEED_LOGIN', null, { root: true }));

            case 4:
              _context.prev = 4;

              if (addLogo) {
                content = content + '来自[CNode.js社区](http://alexlees.github.io)';
              }
              _context.next = 8;
              return Object(__WEBPACK_IMPORTED_MODULE_2__util_api__["g" /* postReply */])({ accesstoken: accesstoken, content: content, reply_id: reply_id, topic_id: topic_id });

            case 8:
              res = _context.sent;

              if (res.success) {
                commit(__WEBPACK_IMPORTED_MODULE_3__user_mutations__["e" /* SUCCESS_TOAST */], { message: '评论成功' }, { root: true });
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_3__user_mutations__["b" /* ERR_TOAST */], { message: res.error_msg }, { root: true });
              }
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](4);

              commit(__WEBPACK_IMPORTED_MODULE_3__user_mutations__["b" /* ERR_TOAST */], { message: '未知错误' }, { root: true });

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 12]]);
    }))();
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutations__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(202);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    author: {
      info: null,
      collects: []
    },
    err: false,
    loading: false,
    errMsg: ''
  },
  mutations: __WEBPACK_IMPORTED_MODULE_0__mutations__["f" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  info: function info(state) {
    if (state.author.info) {
      return state.author.info;
    }
    return {};
  },
  collects: function collects(state) {
    return state.author.collects;
  },
  loading: function loading(state) {
    return state.loading;
  }
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_api__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_mutations__ = __webpack_require__(14);





/* harmony default export */ __webpack_exports__["a"] = ({
  getUser: function getUser(_ref, _ref2) {
    var _this = this;

    var commit = _ref.commit;
    var loginname = _ref2.loginname,
        path = _ref2.path;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (loginname) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return');

            case 2:
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["e" /* SET_LOADING */], { flag: true });
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["c" /* LOADING_TOAST */], { message: '加载中...', flag: true }, { root: true });
              _context.prev = 4;
              _context.next = 7;
              return Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["d" /* fetchUser */])({ loginname: loginname });

            case 7:
              res = _context.sent;

              if (res.success) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["c" /* SET_AUTHOR_INFO */], res);
                if (path) {
                  commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* NEED_ROUTER */], path);
                }
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* SET_ERR */], { flag: true, msg: res.error_msg });
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: res.error_msg });
              }
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](4);

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* SET_ERR */], { flag: true, msg: _context.t0 });
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: '未知错误' });

            case 15:
              _context.prev = 15;

              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["c" /* LOADING_TOAST */], { message: '加载中...', flag: false }, { root: true });
              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["e" /* SET_LOADING */], { flag: false });
              return _context.finish(15);

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[4, 11, 15, 19]]);
    }))();
  },
  getCollect: function getCollect(_ref3, _ref4) {
    var _this2 = this;

    var commit = _ref3.commit,
        state = _ref3.state;
    var loginname = _ref4.loginname;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (loginname) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return');

            case 2:
              _context2.prev = 2;

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["e" /* SET_LOADING */], { flag: true });
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["c" /* LOADING_TOAST */], { message: '加载中...', flag: true }, { root: true });
              _context2.next = 7;
              return Object(__WEBPACK_IMPORTED_MODULE_3__util_api__["e" /* fetchUserTopicCollect */])({ loginname: loginname });

            case 7:
              res = _context2.sent;

              if (res.success) {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* SET_AUTHOR_COLLECTS */], res);
              } else {
                commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* SET_ERR */], { flag: true, msg: res.error_msg });
                commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: res.error_msg }, { root: true });
              }
              _context2.next = 15;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2['catch'](2);

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["d" /* SET_ERR */], { flag: true, msg: _context2.t0 });
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["b" /* ERR_TOAST */], { message: '未知错误' }, { root: true });

            case 15:
              _context2.prev = 15;

              commit(__WEBPACK_IMPORTED_MODULE_2__mutations__["e" /* SET_LOADING */], { flag: false });
              commit(__WEBPACK_IMPORTED_MODULE_4__user_mutations__["c" /* LOADING_TOAST */], { message: '加载中...', flag: false }, { root: true });
              return _context2.finish(15);

            case 19:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[2, 11, 15, 19]]);
    }))();
  }
});

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[55]);


// WEBPACK FOOTER //
// assets/js/app.1d048a47c0b4940a37a2.js